/**
 * API Configuration
 * 
 * Handles API URL resolution for different environments:
 * - Web (Vercel): Uses relative /api/ paths
 * - iOS/Android (Capacitor): Uses full production URL
 */

// Production URL for APIs (verified custom domain)
const PRODUCTION_URL = 'https://calobite.app';

/**
 * Check if running in Capacitor (iOS/Android native app)
 */
export const isCapacitor = () => {
    return window.Capacitor?.isNativePlatform?.() ||
        window.Capacitor?.getPlatform?.() !== 'web';
};

/**
 * Get the base URL for API calls
 * - Returns empty string for web (relative paths work)
 * - Returns production URL for native apps
 */
export const getApiBaseUrl = () => {
    if (isCapacitor()) {
        return PRODUCTION_URL;
    }
    return ''; // Use relative paths on web
};

/**
 * Build full API URL
 * @param {string} path - API path like '/api/send-reset-email'
 */
export const apiUrl = (path) => {
    return `${getApiBaseUrl()}${path}`;
};

export default {
    isCapacitor,
    getApiBaseUrl,
    apiUrl,
    PRODUCTION_URL
};
